import React, { useEffect, useState } from 'react'
import PageHead from '../../Components/PageHead'
import RepairTypeModal from './RepairTypeModal';
import { ApiGetCall } from '../../JS/Connector';

export default function RepairTypes() {
    const [Alerts, setAlerts] = useState("");
    const [loading, setLoading] = useState(false);
    const [RepairTypesData, setRepairTypesData] = useState([]);
    const [RepairTypePopup, setRepairTypePopup] = useState(false);
    const [AddEditFlag, setAddEditFlag] = useState(0);
    const [repairTypeId, setRepairTypeId] = useState(0);
    useEffect(() => {
        GetAllRepairTypes();
    }, []);
    const GetAllRepairTypes = async () => {
        setLoading(true);
        await ApiGetCall("/devices/types/all").then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setLoading(false);
                setRepairTypesData(responseRs);
            }
        });
    }
    return (
        <div>
            <PageHead heading={"Repair Types"} loading={loading} Alerts={Alerts} showsearch={false} />
            <div className="GridBox mt-2 px-3 pb-3">
                <div className='row text-end'>
                    <div className="col-md-9"></div>
                    <div className="col-md-3 my-2">
                        <label className='BorderBtn text-center marginDetailsPopup me-0' title='Add Repair Type'
                            onClick={(e) => { setRepairTypePopup(true); setAddEditFlag(1); setRepairTypeId(0) }}>
                            Add Repair Type
                            <img src='/images/AddInventory.svg' className='img-fluid ps-2' />
                        </label>
                    </div>
                </div>
                <div className="greyBox p-3 data-table-container">
                    <table className="table data-table">
                        <thead className='GridHeader'>
                            <tr>
                                <th scope="col" className='fw-600'>Repair Type</th>
                                <th scope="col" className='fw-600'>Secondary Price?</th>
                                <th scope="col" className='fw-600'>Point</th>
                                <th scope="col" className=' fw-600 text-center'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {RepairTypesData.length != 0 ?
                                RepairTypesData.map((item, i) => {
                                    return <tr key={i} className="OddEvenClass tableBorderHide">
                                        <td className="py-12">
                                            {item.type}
                                        </td>
                                        <td className="py-12">
                                            {item.discount_for_repair_type == 2 ? "No" : "Yes"}
                                        </td>
                                        <td className="py-12">
                                            {item.point}
                                        </td>
                                        <td scope="col" className='text-center py-12'>
                                            <img src='/images/EditIconNew.svg' title='Edit Repair Type' className='img-fluid pe-2 cursor-pointer'
                                                onClick={(e) => { setRepairTypeId(item.id); setAddEditFlag(2); setRepairTypePopup(true) }} />
                                        </td>
                                    </tr>
                                })
                                :
                                <tr className="text-center">
                                    <td colSpan={15}>No Record Found</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {RepairTypePopup && <RepairTypeModal isShow={RepairTypePopup} GetAllRepairTypes={GetAllRepairTypes}
                closepopup={(e) => { setRepairTypePopup(false); setAddEditFlag(0) }}
                flag={AddEditFlag} setLoading={setLoading} setAlerts={setAlerts} repairtypeid={repairTypeId}
            />}
        </div>
    )
}
